/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Switch_2Inputs */

const en_fc_vs_switch_2 = /** @type {(inputs: Fc_Vs_Switch_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep your media in the same folders so FilmCraft can relink it.`)
};

/**
* | output |
* | --- |
* | "Keep your media in the same folders so FilmCraft can relink it." |
*
* @param {Fc_Vs_Switch_2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_switch_2 = /** @type {((inputs?: Fc_Vs_Switch_2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Switch_2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_switch_2(inputs)
});
export { fc_vs_switch_2 as "fc.vs.switch.2" }